module.exports = __webpack_public_path__ + "img/video-banner.5db14dd7.png";